export default [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/auth/Login.vue"),
    meta: {
      drawerOptions: {
        bgColor: "#9de2ff",
        title: "S adveroo je reklama hračkou",
        text:
          "Proměňte své podnikání v úspěšný byznys jako desítky uživatelů před vámi.",
        ico: "ico-umbrella-blue.svg",
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/auth/Registration.vue"),
    meta: {
      drawerOptions: {
        width: 360,
        bgColor: "#9de2ff",
        title: "Zaregistrujte se ještě dnes a získejte 7denní zkušební verzi",
        text:
          "Spravujte s adveroo své Facebookové reklamy, jak jen nejjednodušeji to lze.",
        ico: "ico-registration-blue.svg",
      },
    },
  },
  {
    path: "/verify-email",
    name: "VerifyEmail",
    component: () => import("@/views/auth/VerifyEmail.vue"),
    meta: {
      drawerOptions: {
        bgColor: "#9de2ff",
        title: "S adveroo je reklama hračkou",
        text:
          "Proměňte své podnikání v úspěšný byznys jako desítky uživatelů před vámi.",
        ico: "ico-umbrella-blue.svg",
      },
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("@/views/auth/ResetPassword.vue"),
    meta: {
      drawerOptions: {
        width: 360,
        bgColor: "#FDC9CC",
        title: "Nepamatujete si své heslo do adveroo?",
        text: "Nevěšte hlavu. Pomůžeme vám si vytvořit nové heslo.",
        ico: "ico-security-red.svg",
      },
    },
  },
  {
    path: "/set-password",
    name: "SetPassword",
    component: () => import("@/views/auth/SetPassword.vue"),
    meta: {
      drawerOptions: {
        bgColor: "#FDC9CC",
        title: "Nepamatujete si své heslo do adveroo?",
        text: "Nevěšte hlavu. Pomůžeme vám si vytvořit nové heslo.",
        ico: "ico-security-red.svg",
      },
    },
  },
]
